import { Component } from '@angular/core';
import { ConfirmDialogService } from './confirm-dialog.service';
import { LanguageService } from '../../../core/i18n/language.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {
  readonly dialogService;
  readonly dialog;

  constructor(
    private readonly i18n: LanguageService,
    dialogService: ConfirmDialogService
  ) {
    this.dialogService = dialogService;
    this.dialog = this.dialogService.dialog;
  }

  confirmLabel(): string {
    const state = this.dialog();
    if (state.confirmLabel) {
      return state.confirmLabel;
    }
    return state.mode === 'alert'
      ? this.i18n.t('common.ok')
      : this.i18n.t('common.confirm');
  }

  cancelLabel(): string {
    return this.dialog().cancelLabel ?? this.i18n.t('common.cancel');
  }
}
